// extracted by mini-css-extract-plugin
module.exports = {"warning":"_737eafa"};